import { getAuthorizer } from '@/auth/useAuthorizer'
import { useAuthStore } from '@/auth/useAuthStore'
import { logError } from '@/logger'
import { getRedirectToLogin } from '@/router/guards/common/getRedirectToLogin'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

import { checkPermissionsV1 } from './checkPermissionsV1'
import { checkPermissionsV2 } from './checkPermissionsV2'
import { type HermesGuardFn } from './types'

export const checkPermissions: HermesGuardFn = async (to) => {
  const authStore = useAuthStore()

  if (to.meta.isPublic) return
  if (!authStore.user) return getRedirectToLogin(to)

  const featureFlags = useFeatureFlags()

  if (featureFlags.isEnabled('hermes.rbac.useAuthorizerGuards')) {
    const authorizer = getAuthorizer()
    if (!authorizer) {
      // No authorizer = no comparison possible, just use V1
      return checkPermissionsV1(to, authStore)
    }

    // Run both checks and compare
    const v1Result = checkPermissionsV1(to, authStore)
    const v2Result = checkPermissionsV2(to, authStore)

    const v1Allowed = v1Result === undefined
    const v2Allowed = v2Result === undefined

    if (v1Allowed !== v2Allowed) {
      logError(new Error('Permission check discrepancy between V1 and V2'), {
        context: 'checkPermissions',
        meta: to.meta,
        route: to.path,
        routeName: to.name,
        v1Result: v1Result === undefined ? 'allowed' : 'redirected',
        v2Result: v2Result === undefined ? 'allowed' : 'redirected',
      })
    }

    return v1Result
  }

  return checkPermissionsV1(to, authStore)
}
